export const TOOLTIP_DELAY = 1500;

export const SAVED_QUERY_NAME_SIZE = 260;
